/* FLoating Call-To-Action */
cmmSetupConvertBoost({
    cta_options: [{
        mode: 'modal',
        icon: 'phone',
        color: '#fff',
        icon_color: '#000',
        hide_icon_shadow: true,
        icon_size: 'wti',
        text_shadow: '2px 2px 2px rgba(0,0,0,.2)',
        devices: ['desktop', 'laptop','tablet','mobile'],
        font: {
          family: "AUTO"
        },
      }
    ],
   modal_options: {
    header_text: '<h2>Hey There!</h2>',
    header_color: '#ffffff',
    description_text : 'Ready to transform your space?<br/>Our design team is here to help!',
        font: {
          family: "AUTO"
        },
    buttons: [{
      title: '(508) 544-2813',
      link: 'tel:+15085442813',
      txt_color_hover: '#404345',
      bg_color: '#404345',
      class_list: [
        "call-us"
      ],
      icon: 'phone'
    }, {
      title: 'VISIT SHOWROOM',
      link: 'https://www.google.com/maps/place/Simply+Windows/@42.284019,-71.6013581,17z/data=!4m13!1m7!3m6!1s0x89e40a9901b5405f:0x107355652d73e1c5!2s133+E+Main+St,+Westborough,+MA+01581,+USA!3b1!8m2!3d42.2840151!4d-71.5991694!3m4!1s0x89e4735f45cdb971:0xe121ab011978a3df!8m2!3d42.2840151!4d-71.5991694',
      link_target: '_blank',
      txt_color_hover: '#404345',
      bg_color: '#404345',
      class_list: [
        "visit-showroom"
      ],
      icon: 'map-pin'
    }, {
      title: 'TEXT US',
      link: 'sms:+15086904787',
      txt_color_hover: '#404345',
      bg_color: '#404345',
      class_list: [
        "text-us"
      ],
      // icon: 'email',
      icon: 'sms-solid'
    }, {
      title: 'CONTACT US',
      link: 'https://simply-windows.com/contact-us/',
      txt_color_hover: '#404345',
      bg_color: '#404345',
      class_list: [
        "contact-us"
      ],
      icon: 'email'
    }],
    footer_text: 'Simply Windows is your premier place for window treatments and custom bedding near Westborough, Massachusetts (MA), and the surrounding areas.',
    footer_color: '#000'
  }
}).then( _ => {
  /* Custom Modal Event Tracking */
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .call-us', action: 'Call (508) 544-2813 - ConvertBoost©', event: 'click'}]);
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .visit-showroom', action: 'Visit Showroom - ConvertBoost©', event: 'click'}]);
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .text-us', action: 'Text (508) 690-4787 - ConvertBoost©', event: 'click'}]);
  cmmSetupEventTracking([{selector:'#cmm-call-to-action-modal .request-a-consultation', action: 'Contact Us - ConvertBoost©', event: 'click'}]);
/* Custom Event Tracking */
cmmSetupEventTracking([{selector:'.cmp-navigation__item a[href="/request-consultation"]', action: 'Request Consultation - Menu', event: 'click'}])
});